import React, { useState } from "react";
import { FiX } from "react-icons/fi";
import { Link } from "react-router-dom";

/**
 * AnnouncementBar — slim, dismissible bar for seasonal notices
 * (e.g. wedding-season availability). Content is easy to edit below.
 */
export default function AnnouncementBar() {
  const [visible, setVisible] = useState(true);
  if (!visible) return null;

  return (
    <div className="announcement-bar">
      <div className="container-wide announcement-bar-inner">
        <p>
          Wedding season dates are filling up. <Link to="/plan-your-event">Check availability &rarr;</Link>
        </p>
        <button aria-label="Dismiss announcement" onClick={() => setVisible(false)}>
          <FiX size={16} />
        </button>
      </div>
    </div>
  );
}
